<template>
  <div
    class="product-buy-button-fi"
    @click.stop
  >
    <loading-indicator-wrapper
      :loading="isInProgress"
      dark
      variant="spinnerLocal"
      spinoff="in-relative-centered"
      :class="[
        'product-buy-button-fi__loader-wrapper',
        shopType ? `product-buy-button-fi__loader-wrapper--${shopType}` : '',
      ]"
    >
      <button-fi
        v-if="!isButtonHidden"
        :disabled="isButtonDisabled"
        :data-productid="item ? item.ID : null"
        :data-productname="item ? `${item.ID} - ${item.catalogProductData.ProductName}` : null"
        :aria-label="$dict.get('checkout.Cart.Add-Basket')"
        type="button"
        :class="[
          'button-fi__icon',
          'button-fi__primary',
          'product-buy-button-fi__cart-button',
          shopType ? `product-buy-button-fi__cart-button--${shopType}` : '',
        ]"
        data-test="product-buy-button"
        :data-test-2="isButtonDisabled ? 'product-buy-button-disabled' : null"
        @click.stop="$emit('add-product', productDetails)"
      >
        <icon-fi
          icon="shopping-cart"
          color="white"
        />
      </button-fi>
    </loading-indicator-wrapper>
  </div>
</template>

<script>
import { ButtonFi, IconFi, LoadingIndicatorWrapper } from 'atoms';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductBuyButtonFi',
  components: {
    ButtonFi,
    IconFi,
    LoadingIndicatorWrapper,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    productDetails: {
      type: Object,
      default: () => ({}),
    },
    isInProgress: {
      type: Boolean,
      default: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isButtonHidden: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['add-product'],
  computed: {
    ...mapGetters({
      shopType: 'productList/getShopType',
    }),
  },
};
</script>

<style scoped src="./product-buy-button-fi" />
